<template>
  <v-dialog
    v-model="dialog"
    width="500px"
    style="z-index: 9999;"
  >
    <v-card>
      <v-toolbar dense elevation="0">
        <v-toolbar-title>{{ $t("dialog.update_vehicle.title") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn @click="store" elevation="0" color="primary">
          {{ $t("dialog.update_vehicle.store") }}
        </v-btn>
        <v-btn icon @click="dialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider class="mx-2" />

      <v-container>
        <validation-observer ref="form_validation">
          <form @submit.prevent="submit">
            <v-row class="px-2">
              <v-col cols="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="view.vehicle.name"
                  rules="required|max:50"
                >
                  <v-text-field
                    v-model="name"
                    :counter="50"
                    :error-messages="errors"
                    :label="$t('view.vehicle.name')"
                    required
                  ></v-text-field>
                </validation-provider>

                <PersonField v-model="driver" :label="$t('view.vehicle.driver')" clearable />
              </v-col>
            </v-row>
          </form>
        </validation-observer>
      </v-container>
    </v-card>

    <v-snackbar
      v-model="showError"
      bottom
      light
      timeout="-1"
      color="red lighten-4"
    >
      {{ errorMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="indigo"
          text
          v-bind="attrs"
          @click="showError = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>

import { DateTime } from "luxon";
import i18n from "@/plugins/i18n";
import PersonField from "@/components/fields/PersonField.vue";

export default {
  name: "VehicleUpdateDialog",
  components: { PersonField },

  data() {
    return {
      dialog: false,
      vehicle: null,

      serviceMenu: false,
      motMenu: false,
      tachographMenu: false,

      name: null,
      driver: null,

      showError: false,
      errorMessage: null
    };
  },

  methods: {
    open(vehicle) {
      this.$store.dispatch("data/fetchVehicle", vehicle.vehicleId).then(response => {
        const v = response.data;
        this.vehicle = v;


        this.name = v.name;
        this.driver = (v.driverId !== null) ? { personId: v.driverId } : null;

        this.dialog = true;
        if (this.$refs.form_validation !== undefined)
          this.$refs.form_validation.reset();
      });
    },

    async store() {
      if (await this.$refs.form_validation.validate()) {
        let update = {};

        if (this.vehicle.name !== this.name)
          update["name"] = this.name;
        const driverId = (this.driver !== null) ? this.driver.personId : null;
        if (this.vehicle.driverId !== driverId)
          update["driverId"] = driverId;

        let response = await this.$store.dispatch("data/updateVehicle", {
          vehicleId: this.vehicle.vehicleId,
          body: update
        });

        if (response.error) {
          this.showError = true;
          this.errorMessage = response.message;
        } else {
          this.$store.dispatch("online/refresh", false);

          this.dialog = false;
        }

      }
    },

    getIsoLocale() {
      return i18n.messages[i18n.locale].lang.iso;
    },

    formatDate(day) {
      return (day !== null) ? DateTime.fromISO(day).toLocaleString(DateTime.DATE_SHORT) : "";
    }
  },

  watch: {
    dialog(newValue) {
      if (newValue === false)
        this.$store.dispatch("dialogs/hideDialog", "vehicleUpdate");
    }
  }
};
</script>